<template>
    <div>
        <div>
            <div
                v-if="priceDetail"
                class="flex justify-center">
                <div class="max-w-full overflow-x-auto mb-5">
                    <ul class="steps mb-5 m-auto">
                        <li
                            v-for="(item, index) in priceDetail.positions"
                            :key="index"
                            class="flex items-center flex-col w-72 justify-start step">
                            <div class="w-72 mr-2">
                                <span>
                                    {{ item.nodeTypeName }}
                                </span>
                                <hts-form-select
                                    v-model="itemSelected[index]"
                                    required
                                    :clearable="false"
                                    :items="itemsSelect[index]"
                                    class="mr-2"
                                    :prop="'quoteEquals' + index"
                                    key-id="node"
                                    key-label="fullNameNode"
                                    @change="handleChangeNode" />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <hts-form-button
                v-if="priceDetail && priceDetail.type === 'internal'"
                class="text-right pr-5"
                color="primary"
                type="button"
                @click="openPopopOfflineFee">
                {{ $t('labels.offlineFee') }}
            </hts-form-button>
            <div
                v-if="priceDetail"
                class="px-64 py-20">
                <div class="table w-full">
                    <div class="table-row">
                        <div class="table-cell border w-5/12 p-2">
                            <div class="flex flex-col space-x-1">
                                <span class="label font-bold">
                                    {{ $t('labels.assumptionGasOline') }}
                                </span>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.oilPriceNotVat') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.priceOline.price) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.costingOlinePriceKM') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.priceOline.priceKm) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="table-cell border-t border-b border-r p-2">
                            <div class="flex flex-col space-x-1">
                                <span class="label font-bold">
                                    {{ $t('labels.assumptionOther') }}
                                </span>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.vehicleType') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.vehicleType) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.totalVehicleInternal') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.totalVehicle) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.travelTimeHour') }}
                                    </span>
                                    <span>
                                        {{ $formatters.timeToString(priceDetail.assumption.travelTime) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.totalTaskByHorse') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.totalTask) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.workingDayByMonth') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.workingDayByMonth) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.averageTravelTimeByMonth') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.averageTravelTimeByMonth) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.totalKmRoute') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.totalKm) }}
                                    </span>
                                </div>
                                <div class="flex justify-between">
                                    <span>
                                        {{ $t('labels.totalKmHaveGoods') }}
                                    </span>
                                    <span>
                                        {{ $formatters.formatCurrency(priceDetail.assumption.totalKmHaveGoods) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table w-full pt-10">
                    <div class="table-row">
                        <div class="table-cell border w-5/12 p-2">
                            <div class="flex justify-between items-center">
                                <div class="flex items-center gap-2">
                                    <span class="font-bold">
                                        {{ $t('labels.basicCosts') }}
                                    </span>
                                    <hts-tooltip class="">
                                        <div>
                                            <span class="font-bold">
                                                {{ $t('labels.basicCostInformation') }}
                                            </span>
                                        </div>
                                        <template #reference>
                                            <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                        </template>
                                    </hts-tooltip>
                                </div>
                                <span class="font-bold">
                                    {{ $t('labels.VND') }}
                                </span>
                            </div>
                        </div>
                        <div class="table-cell border-t border-b border-r p-2">
                            <div class="flex justify-between items-center">
                                <div class="flex items-center gap-2">
                                    <span class="font-bold">
                                        {{ $t('labels.customCost') }}
                                    </span>
                                    <hts-tooltip class="">
                                        <div>
                                            <span class="font-bold">
                                                {{ $t('labels.customCostInformation') }}
                                            </span>
                                        </div>
                                        <template #reference>
                                            <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                                        </template>
                                    </hts-tooltip>
                                </div>
                                <span class="font-bold">
                                    {{ $t('labels.VND') }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="table-row">
                        <div class="table-cell border-l border-b border-r w-5/12 p-2">
                            <div class="flex flex-col space-x-1">
                                <div v-if="priceDetail.costingSetting && Object.keys(priceDetail.costingSetting).length">
                                    <div
                                        v-for="(item, index) in priceDetail.costingSetting"
                                        :key="index"
                                        class="flex justify-between">
                                        <span>
                                            {{ item.text }}
                                        </span>
                                        <span>
                                            {{ $formatters.formatCurrency(item.value) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-cell border-b border-r p-2">
                            <div class="flex flex-col space-x-1">
                                <div v-if="normalGoods">
                                    <div
                                        v-for="(item, index) in normalGoods.costingDetail"
                                        :key="index"
                                        class="flex justify-between">
                                        <span>
                                            {{ item.name }}
                                        </span>
                                        <span>
                                            {{ $formatters.formatCurrency(item.amount) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row border bg-yellow-500">
                        <div class="table-cell border-l border-b border-r p-2 w-5/12">
                            <span class="text-2xl font-bold">
                                {{ $t('labels.totalCostingOrdinaryGoods') }}
                            </span>
                        </div>
                        <div class="table-cell border-b border-r p-2 text-right">
                            <span class="text-2xl font-bold">
                                {{ $formatters.formatCurrency(normalGoods.totalCosting) }}
                            </span>
                        </div>
                    </div>

                    <div
                        v-for="(otherGood, index) in otherGoods"
                        :key="index"
                        class="table-row-group">
                        <div class="table-row">
                            <div class="table-cell border-l border-b border-r w-5/12 p-2">
                                <div class="flex flex-col space-x-1" />
                            </div>
                            <div class="table-cell border-b border-r p-2">
                                <div class="flex flex-col space-x-1">
                                    <div v-if="otherGood">
                                        <div
                                            v-for="(item, indexOtherGood) in otherGood.costingDetail"
                                            :key="indexOtherGood"
                                            class="flex justify-between">
                                            <span>
                                                {{ item.name }}
                                            </span>
                                            <span>
                                                {{ $formatters.formatCurrency(item.amount) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            :key="index"
                            class="table-row border bg-yellow-500">
                            <div class="table-cell border-l border-b border-r p-2 w-5/12">
                                <span class="text-2xl font-bold">
                                    {{ labelCosting[otherGood._id] }}
                                </span>
                            </div>
                            <div class="table-cell border-b border-r p-2 text-right">
                                <span class="text-2xl font-bold">
                                    {{ $formatters.formatCurrency(otherGood.total) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="table-row border bg-gray-200">
                        <div class="table-cell border-l border-b border-r p2 w-5/12">
                            <span class="text-2xl font-bold">
                                Tổng chi phí hệ thống
                            </span>
                        </div>
                        <div class="table-cell border-b border-r p-2 text-right">
                            <span class="text-2xl font-bold">
                                {{ $formatters.formatCurrency(priceDetail.pricingEstimate.totalSystem) }}
                            </span>
                        </div>
                    </div>

                    <div class="table-row border bg-gray-300">
                        <div class="table-cell border-l border-b border-r px-2 py-10 w-5/12">
                            <span class="text-2xl font-bold">
                                Tổng chi phí thực tế
                            </span>
                        </div>
                        <div class="table-cell border-b border-r p-2 text-right">
                            <span class="text-2xl font-bold">
                                {{ $formatters.formatCurrency(priceDetail.pricingEstimate.total) }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hts-modal
            :size="50"
            :show="openOfflineFee"
            :title="$t('labels.offlineFee')"
            @close="openOfflineFee = false">
            <table class="w-full table-fixed text-center dark:text-gray-400 border-collapse border border-gray-800">
                <thead>
                    <tr>
                        <th class="w-1/2 border border-gray-800">
                            {{ $t('labels.route') }}
                        </th>
                        <th class="pl-2 border border-gray-800">
                            {{ $t('labels.supplyList.price') }}
                        </th>
                        <th class="border border-gray-800">
                            {{ $t('labels.offlineFee') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in priceOfflineFee"
                        :key="index"
                        class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                        <td class="break-words border border-gray-800">
                            {{ getRouteName(item.positions) }}
                        </td>
                        <td class="font-bold border border-gray-800">
                            {{ $formatters.formatCurrency(item.pricingEstimate.total) }}
                        </td>
                        <td class="font-bold border border-gray-800">
                            {{ $formatters.formatCurrency(item.pricingEstimate.totalOfflineFee) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import { ISearchPriceDetail } from '../quote-request/-components/ignore/imports/form'

const { $formatters } = useNuxtApp()
const { $disableReactive } = useNuxtApp()

const priceDetail = ref<ISearchPriceDetail>()
const priceOfflineFee = ref<Array<ISearchPriceDetail>>()

const visible = ref(false)
const close = () => {
  visible.value = false
}

const normalGoods = computed(() => {
  const result =
    priceDetail.value &&
    priceDetail.value.priceCosting &&
    priceDetail.value.priceCosting.find((item) => {
      return item._id === 'NORMAL'
    })
  if (result) {
    return result
  }
  return {}
})

const otherGoods = computed(() => {
  const result =
    priceDetail.value &&
    priceDetail.value.priceCosting &&
    priceDetail.value.priceCosting.filter((item) => {
      return item._id !== 'NORMAL'
    })
  if (result) {
    return result
  }
  return []
})

const props = defineProps({
  pPriceDetail: {
    type: Object as PropType<ISearchPriceDetail>,
    required: true
  },
  pPriceOfflineFee: {
    type: Object as PropType<ISearchPriceDetail>,
    required: true
  }
})

const { pPriceDetail, pPriceOfflineFee } = toRefs(props)

onBeforeMount(() => {
  priceDetail.value = $disableReactive(pPriceDetail.value)
  priceOfflineFee.value = $disableReactive(pPriceOfflineFee.value)
  visible.value = true
  if (priceDetail.value && priceDetail.value.type === 'internal') {
    totalItemsPrices.value = $disableReactive([priceDetail.value]).concat(priceOfflineFee.value)
  } else {
    totalItemsPrices.value = $disableReactive([priceDetail.value])
  }
})

const totalItemsPrices = ref()

const itemsSelect = computed(() => {
  const result: Array<Array<{ [key: string]: any }>> = []
  if (priceDetail.value) {
    priceDetail.value.positions.forEach((position, index) => {
      const nodePushed = [] as string[]
      result[index] = []
      itemSelected.value[index] = position.node
      totalItemsPrices.value.forEach((totalItemsPrice: { [key: string]: any }) => {
        if (!nodePushed.includes(totalItemsPrice.positions[index].node)) {
          result[index].push(totalItemsPrice.positions[index])
        }
        nodePushed.push(totalItemsPrice.positions[index].node)
      })
    })
  }
  return result
})

const itemSelected = ref<Array<string>>([])

const labelCosting = {
  NORMAL: $t('labels.totalCostingOrdinaryGoods'),
  FROZEN: $t('labels.totalCostingCoolGoods'),
  DANGEROUS: $t('labels.totalCostingHazardousGoods'),
  FRAGILE: $t('labels.totalCostingFragileGoods'),
  LIQUID: $t('labels.totalCostingLiquidGoods'),
  GAS: $t('labels.totalCostingGasGoods'),
  OVERWEIGHT: $t('labels.totalCostingSuperHeavyGoods')
}

const handleChangeNode = () => {
  if (priceDetail.value) {
    const data = totalItemsPrices.value.find((item: { [key: string]: any }) => {
      let result = true
      itemSelected.value.forEach((i, index: number) => {
        if (!(i === item.positions[index].node)) {
          result = false
        }
      })
      return result
    })
    if (data) {
      priceDetail.value = data
    }
  }
}
const openOfflineFee = ref(false)
const openPopopOfflineFee = () => {
  openOfflineFee.value = true
}

const getRouteName = (positions: Array<{ [key: string]: any }>) => {
  if (positions && Array.isArray(positions)) {
    const pluckData = $lodash.map(positions, 'fullNameNode')

    return $lodash.join(pluckData, ' >> ')
  }
}
</script>
